export default "__VITE_ASSET__Bo27Fui0__"